<template>
<!--    <v-main-->
<!--            v-if="landing_data"-->
<!--            style="height: 100vh; object-fit: cover"-->
<!--            :style="{ 'background': landing_data.background_type === '1' ? landing_data.background_color : landing_data.background_image }"-->
<!--    >-->
<!--        <v-img-->
<!--                :src="$vuetify.breakpoint.smAndDown ? landing_data.cover_image_mobile : landing_data.cover_image_desktop"-->
<!--               contain height="100%"-->
<!--        ></v-img>-->
<!--&lt;!&ndash;        <div style="position: absolute; top: 50%; right: 50%;">&ndash;&gt;-->
<!--&lt;!&ndash;            {{landing_data.title}}&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="d-flex justify-center layout-position">-->
<!--            <div class="px-10 layout-button" :style="{ 'background': landing_data.button_color ? landing_data.button_color : 'white'}">-->
<!--                <div class="d-flex justify-center align-center" style="height: 100%">-->
<!--                    <span class="link-btn vhtml" :style="{'color': landing_data.font_color ? landing_data.font_color : '#222'}" @click="enterSite('th')">เข้าชมเว็บไซต์</span>-->
<!--                    <span class="mx-3" :style="{'color': landing_data.font_color ? landing_data.font_color : '#222'}">|</span>-->
<!--                    <span class="link-btn vhtml" :style="{'color': landing_data.font_color ? landing_data.font_color : '#222'}" @click="enterSite('en')">Enter Site</span>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </v-main>-->
  <div
              v-if="landing_data"
              style="height: 100vh; "
              :style="{ 'background': landing_data.background_type === '1' ? landing_data.background_color : landing_data.background_image }"
  >
    <div style="height: calc(100% - 80px); overflow: hidden">
      <v-img
          eager
          :contain="$vuetify.breakpoint.mdAndUp"
          width="100%"
          max-height="100%"
          position="center center"
          :src="$vuetify.breakpoint.smAndDown ? landing_data.cover_image_mobile : landing_data.cover_image_desktop"
      ></v-img>
    </div>
    <v-layout justify-center align-center style="height: 80px" :style="{ 'background': landing_data.button_color ? landing_data.button_color : 'white'}">
      <v-flex shrink>
        <div class="px-10 layout-button">
          <div class="d-flex justify-center align-center" style="height: 100%">
            <span class="link-btn vhtml" :style="{'color': landing_data.font_color ? landing_data.font_color : '#222'}" @click="enterSite('th')">เข้าชมเว็บไซต์</span>
            <span class="mx-3" :style="{'color': landing_data.font_color ? landing_data.font_color : '#222'}">|</span>
            <span class="link-btn vhtml" :style="{'color': landing_data.font_color ? landing_data.font_color : '#222'}" @click="enterSite('en')">Enter Site</span>
          </div>
        </div>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: "LandingPage",
        computed: {
          ...mapState({
              landing_data: state => {
                  if (state.Landing.landing_data) {
                      return state.Landing.landing_data
                  }
              },
              lang: state => state.Branch.lang
          })
        },
        async created() {
          await this.$store.dispatch('Landing/getBannerBg');
          if (!this.landing_data) {
              this.$router.push(`/${this.lang}`+"/home");
          }
        },
        methods: {
            async enterSite(lang) {
                this.$i18n.locale = lang;
                await this.$store.commit('Branch/setLang', lang);
                this.$router.push(`/${this.lang}`+"/home");
            }
        }
    }
</script>

<style scoped>
    .layout-position {
        /*position: fixed;*/
        bottom: 0px;
        left: 0;
        right: 0;
    }
    .layout-button {
        height: 50px;
        border-radius: 30px;
        border: 1px solid #ccc;
        background: white;
    }
    .link-btn {
        color: #222;
        cursor: pointer;
        user-select: none;
    }
    .link-btn:hover {
        color: #34A93E;
    }
    img{
      margin-top: 0;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      justify-content: space-around;
    }
</style>
